/**
 * Klucze zapytań React Query, które unieważnia zmiana typu wniosku o nieobecność (ustawienie
 * klienta, typy dokumentów klas `specjalne`/`internal`). Jedno miejsce zamiast literałów, żeby
 * odświeżenie po zapisie w Ustawieniach trafiało w te same zapytania, które czytają menu i pulpit.
 */

/** `GET /api/my/installed-modules` — obszary menu + obowiązujący typ (skrót „Nieobecności"). */
export const INSTALLED_MODULES_QUERY_KEY = ['my', 'installed-modules'] as const;

/** `GET /api/hr/metrics` — kafelki pulpitu Kadr (w tym „Urlopy"). */
export const HR_METRICS_QUERY_KEY = ['hr-metrics'] as const;

/** `GET /api/settings/hr-absence-type` — stan ustawienia (kolumna „Wniosek o nieobecność" w tabeli typów). */
export const HR_ABSENCE_TYPE_SETTING_QUERY_KEY = ['settings', 'hr-absence-type'] as const;

/**
 * Prefiks zapytań `GET /api/document-types` — listy typów (tabela w Ustawieniach → „Typy
 * dokumentów", z kluczem klasy i filtrów dalej w kluczu). Odświeżany osobno od
 * `HR_ABSENCE_TYPE_DEPENDENT_QUERY_KEYS`: tylko po błędzie „nieaktualny typ", żeby wiersz typu
 * usuniętego albo wycofanego zniknął z tabeli.
 */
export const DOCUMENT_TYPES_QUERY_KEY = ['document-types'] as const;

/** Wszystkie klucze do odświeżenia po zmianie ustawienia albo typów, z których się wybiera. */
export const HR_ABSENCE_TYPE_DEPENDENT_QUERY_KEYS = [
  HR_ABSENCE_TYPE_SETTING_QUERY_KEY,
  INSTALLED_MODULES_QUERY_KEY,
  HR_METRICS_QUERY_KEY,
] as const;
